import { createFileRoute } from "@tanstack/react-router";
import { abs } from "@/lib/site";
import { SiteHeader, SiteFooter } from "@/components/SiteChrome";
import { PackBuilder } from "@/components/PackBuilder";

export const Route = createFileRoute("/pack/")({
  head: () => ({
    meta: [
      { title: "Create a shareable symbol pack" },
      {
        name: "description",
        content:
          "Bundle your favourite symbols into a curated pack and share it with one link. The whole pack lives in the URL — no account, no server, works for anyone you send it to.",
      },
      { property: "og:title", content: "Create a shareable symbol pack" },
      {
        property: "og:description",
        content: "Curate symbols into a pack and share it with a single stateless link.",
      },
      { property: "og:url", content: abs("/pack") },
    ],
    links: [{ rel: "canonical", href: abs("/pack") }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebApplication",
          name: "Symbol pack builder",
          applicationCategory: "UtilityApplication",
          operatingSystem: "Any",
          url: "/pack",
          offers: { "@type": "Offer", price: "0", priceCurrency: "USD" },
        }),
      },
    ],
  }),
  component: PackIndex,
});

function PackIndex() {
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="mx-auto w-full max-w-4xl flex-1 px-4 py-12 sm:px-6 sm:py-16">
        <h1 className="font-display text-4xl font-bold sm:text-5xl">
          Shareable <span className="text-gradient">symbol packs</span>
        </h1>
        <p className="mt-4 max-w-2xl text-lg text-foreground/85">
          Pick symbols from your tray, favourites and recently viewed, give the set a name, and get
          a link you can share anywhere. The pack is encoded entirely into the URL, so there's
          nothing to sign up for and nothing stored on a server.
        </p>

        <PackBuilder />
      </main>
      <SiteFooter />
    </div>
  );
}
